var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 8,
    fill: "none",
    viewBox: "0 0 5 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m.56 6.714 2.778-2.705L.561 1.286C.18.923.797.306 1.178.67l3.158 3.086c.127.127.146.363.018.49L1.178 7.331c-.381.363-.998-.254-.617-.617",
    clipRule: "evenodd"
  })));
};
export default SvgChevronRight;